import { useContext } from 'react'
import { NotificationContext } from '../context/notification-context'
import { NotificationContextProps } from '../types'

/**
 * provides notification context if used inside the notification provider
 */
const useNotificationContext = (): NotificationContextProps => {
  const notificationContext = useContext(NotificationContext)

  if (notificationContext === undefined) {
    throw new Error('notification context is used outside of its provider')
  }

  return notificationContext
}

export default useNotificationContext
